var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16663 13.8333H3.21788L11.7483 5.30292L10.697 4.25167L2.16663 12.7821V13.8333ZM0.916626 15.0833V12.2629L11.9087 1.27562C12.0347 1.16118 12.1738 1.07278 12.326 1.01042C12.4784 0.947916 12.6381 0.916666 12.8052 0.916666C12.9723 0.916666 13.1341 0.946319 13.2906 1.00562C13.4473 1.06493 13.5859 1.15923 13.7066 1.28854L14.7243 2.31896C14.8536 2.43965 14.9458 2.57854 15.0008 2.73562C15.0558 2.89271 15.0833 3.04979 15.0833 3.20687C15.0833 3.37451 15.0547 3.53444 14.9975 3.68667C14.9402 3.83903 14.8492 3.97819 14.7243 4.10417L3.73704 15.0833H0.916626ZM11.2135 4.78646L10.697 4.25167L11.7483 5.30292L11.2135 4.78646Z",
    fill: "#5F6376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fbe4493e9591d7727947390bbfca3298.svg";
export { ForwardRef as ReactComponent };